import LocalizedStrings from 'localized-strings';

interface CreateNewTransferCheckDetailsLocalizedType {
  amount: string;
  checkDetails: string;
  confirm: string;
  feeDetails: string;
  fees: string;
  label: string;
  noneLabel: string;
  internalTransfer: string;
  internalTransferTooltip: string;
  transferRecap: string;
  transferType: string;
}

export default new LocalizedStrings<CreateNewTransferCheckDetailsLocalizedType>(
  {
    en: {
      amount: 'Amount',
      checkDetails: 'Verify information',
      confirm: 'Confirm transfer',
      feeDetails:
        "Internal transfers between your Shine wallets are free and unlimited. They're not included in your monthly transaction limits.",
      fees: 'Fees',
      internalTransfer: 'Internal',
      internalTransferTooltip:
        'Internal transfers between your Shine wallets are always instantaneous: they are credited in seconds.',
      label: 'Label',
      noneLabel: 'None',
      transferRecap: 'Transfer summary',
      transferType: 'Type of transfer',
    },
    fr: {
      amount: 'Montant',
      checkDetails: 'Vérifiez les informations',
      confirm: 'Confirmer l’envoi',
      feeDetails:
        'Les virements internes à vos comptes Shine sont gratuits et illimités. Ils ne sont pas comptabilisés dans vos limites de mouvements mensuels.',
      fees: 'Frais',
      internalTransfer: 'Interne',
      internalTransferTooltip:
        'Les virements internes à vos comptes Shine sont toujours instantanés : ils sont crédités en quelques secondes.',
      label: 'Libellé',
      noneLabel: 'Aucun',
      transferRecap: 'Récapitulatif du virement',
      transferType: 'Type de virement',
    },
  } as const,
);
